import { trigger, state, style, AUTO_STYLE, transition, animate } from '@angular/animations';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    EventEmitter,
    Output,
    signal,
} from '@angular/core';
import { ButtonComponent, IconComponent } from '@sirius/common';
import { TranslatePipe } from '@ngx-translate/core';

export enum ContentExpansionStatesEnum {
    collapsed = 'colllapsed',
    expanded = 'expanded',
}

const DEFAULT_DURATION = 300;

@Component({
    selector: 'commerce-content-expansion-container',
    templateUrl: './content-expansion-container.component.html',
    styleUrl: './content-expansion-container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('collapse-expand', [
            state(ContentExpansionStatesEnum.expanded, style({ height: AUTO_STYLE, visibility: AUTO_STYLE })),
            state(ContentExpansionStatesEnum.collapsed, style({ height: '0', visibility: 'hidden' })),
            transition(ContentExpansionStatesEnum.expanded + ' => ' + ContentExpansionStatesEnum.collapsed, animate(DEFAULT_DURATION + 'ms ease-in')),
            transition(ContentExpansionStatesEnum.collapsed + ' => ' + ContentExpansionStatesEnum.expanded, animate(DEFAULT_DURATION + 'ms ease-out')),
        ]),
    ],
    imports: [ButtonComponent, IconComponent, TranslatePipe]
})
export class ContentExpansionContainerComponent {
    // Used for making unique ids in case more than one instance of this component is used.
    static instanceCount = 0;
    uniqueContentId: string;

    @Output()
    toggleDone = new EventEmitter<void>();

    contentExpansionState = signal(ContentExpansionStatesEnum.collapsed);

    isCollapsed = computed(
        () => this.contentExpansionState() === ContentExpansionStatesEnum.collapsed,
    );

    constructor() {
        ContentExpansionContainerComponent.instanceCount++;
        this.uniqueContentId = this.createUniqueId();
    }

    toggleContent() {
        this.contentExpansionState.set(
            this.isCollapsed()
                ? ContentExpansionStatesEnum.expanded
                : ContentExpansionStatesEnum.collapsed,
        );

        if (this.contentExpansionState() === ContentExpansionStatesEnum.collapsed) {
            this.toggleDone.emit();
        }
    }

    private createUniqueId() {
        return `content-${ContentExpansionContainerComponent.instanceCount}`;
    }
}
